export default __webpack_public_path__ + "static/media/house-4.87e56bd0.jpg";